import { OrderType } from './order-type';
import { PriceType } from './loose-order';

export interface OrderPriceChange {
	id: number;
	orderId: number;
	orderType: OrderType;
	oldNetPrice: number;
	oldGrossPrice: number;
	oldPriceType: PriceType;
	newNetPrice: number;
	newGrossPrice: number;
	newPriceType: PriceType;
	createdAt: number;
	createdBy: number;
}
